export default __webpack_public_path__ + "static/media/style3.6925867a.svg";